import cn from 'classnames';
import styles from './PaymentProgressBar.module.scss';

interface PaymentProgressBarProps {
  title?: string;
  className?: string;
}

export const PaymentProgressBar = ({
  title = 'Loading payment options…',
  className,
}: PaymentProgressBarProps) => {
  return (
    <div className={cn(styles.root, className)}>
      <p className={styles.animatedText}>{title}</p>
    </div>
  );
};
